import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--toast"
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 4000 },
  };

  connect() {
    this._show();
    setTimeout(() => this._hide(), this.durationValue);
  }

  // TODO hiddenの設定はデザインと要調整
  _show() {
    this.element.classList.remove("hidden");
  }

  _hide() {
    this.element.classList.add("hidden");
    this.element.remove();
  }
}
